"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusModeListener = void 0;
var _useFocusMode = require("./useFocusMode");
/**
 * This hook listens to the marker class applied to the document body
 * and causes a re-render when it changes.
 *
 * We use this for performance so we don't have to use `useFocusMode` more
 * than we need.
 *
 * @param enabled if true, this listener is enabled. If false, all functions will be paused.
 *               This can be helpful to only turn it on in some cases, since it is extra overhead.
 * @deprecated, please use useFocusMode instead.
 */
const useFocusModeListener = function () {
  let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const {
    focusMode
  } = (0, _useFocusMode.useFocusMode)({
    isDisabled: !enabled
  });
  return focusMode;
};
exports.useFocusModeListener = useFocusModeListener;
//# sourceMappingURL=useFocusModeListener.js.map